export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
            <path d="M12.7446 14.9902L13.8843 16.9716" stroke="#D19F5D" strokeLinecap="round" />
            <path d="M5.39795 14.9902L4.2583 16.9716" stroke="#D19F5D" strokeLinecap="round" />
            <circle cx="2.78571" cy="2.4195" r="2.28571" fill="url(#paint0_linear_567_3447)" />
            <circle cx="14.2144" cy="2.4195" r="2.28571" fill="url(#paint1_linear_567_3447)" />
            <circle cx="8.5" cy="8.13379" r="7.5" fill="#FDF6E8" stroke="url(#paint2_linear_567_3447)" />
            <path d="M8.5 4.70508L8.5 9.27651" stroke="url(#paint3_linear_567_3447)" strokeLinecap="round" />
            <path d="M8.5 9.27637H11.9286" stroke="#CD9A58" strokeLinecap="round" />
            <defs>
                <linearGradient id="paint0_linear_567_3447" x1="2.78571" y1="0.133789" x2="2.78571" y2="4.70522" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F1CC88" />
                    <stop offset="1" stopColor="#D09E5C" />
                </linearGradient>
                <linearGradient id="paint1_linear_567_3447" x1="14.2144" y1="0.133789" x2="14.2144" y2="4.70522" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F1CC88" />
                    <stop offset="1" stopColor="#D09E5C" />
                </linearGradient>
                <linearGradient id="paint2_linear_567_3447" x1="15" y1="1.13379" x2="8.5" y2="16.1338" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD997" />
                    <stop offset="1" stopColor="#CE9B5A" />
                </linearGradient>
                <linearGradient id="paint3_linear_567_3447" x1="9" y1="4.70508" x2="9" y2="9.27651" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EBC380" />
                    <stop offset="1" stopColor="#C89351" />
                </linearGradient>
            </defs>
        </svg>
    );
}
